module.exports = __webpack_public_path__ + "static/showreel-wide-14f1ae74ee71273e2cf4ee3d7b66ef16.mp4";